import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { ModalService } from 'src/app/services/modal.service';
import { ValidatorService } from 'src/app/services/validator.service';

@Component({
  selector: 'payment-link-email-modal',
  templateUrl: './payment-link-email-modal.component.html',
  styleUrls: ['./payment-link-email-modal.component.scss']
})
export class PaymentLinkEmailModalComponent {

  public email  = null;
    public id     = null;
    public loader = false;
    public dataItem = {
      email: "",
      id: null,
      payment_id: null
    }
    public paymentLink:any = false;
  
    constructor(
      public dialog: MatDialogRef<PaymentLinkEmailModalComponent>,
      @Inject(MAT_DIALOG_DATA) public d,
      private api: ApiService,
      private modal: ModalService,
      private validator: ValidatorService
    ){
  
      this.dataItem.email      = this.d.email;
      this.dataItem.id         = this.d.id;
      this.dataItem.payment_id = this.d.paymentId  
  
    }
    
    /**
     * 
     * Send
     * 
     */
    send(){
  
      try{
  
        this.validator.clear();
        this.validator.isEmpty(this.dataItem.email,"email","- Informe o E-mail para recebimento do voucher.");
        
        if(!this.validator.passes()){
  
          this.modal.open(this.validator.getMessagesHtml());  
          return false;
  
        }
  
        this.loader = true;
  
  
        this.api.paymentLink().order().email().sendLink(this.dataItem).subscribe(response => {
  
          this.loader = false;
  
          if(response.status == 1){
  
            this.modal.open(`O Link para Pagamento foi enviado para o e-mail: <strong>${this.dataItem.email}</strong>`)
  
          }else{
  
            let error   = this.api.formatError(response);
            this.modal.open(error.message);
  
          }
  
        },(response) => {
  
            this.loader = false;
            let error   = this.api.formatError(response);
            this.modal.open(error.message);
  
        });
  
        
  
      }catch(e){
  
        this.loader = false;
        this.modal.open(e.message);
  
      }
  
  
    }
    /**
     * 
     * Init
     * 
     */
    ngOnInit():void{}

}
